// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { inViewAnm, lenisPageScroll, mvAnim, slideLoop, sideNav } from './libs/Scroll';
import { drawer, fixedHeader, megaMenu } from './libs/Header';
import { addAutoFunc, confirmForm, numKeyFunc, reservationCalendarFunc } from './libs/Form';
import { accordionFunc } from './libs/Accordion';
import { archiveDropdown } from './libs/Dropdown';
import { createIndex } from './libs/CreateIndex';
import { ScrollHintFunc } from './libs/ScrollHint';
// import { modal } from './libs/Modal';
import { slider } from './libs/Slider';
import { tabFunc } from './libs/Tab';
import { ImageRing } from './libs/ImageRing';
import { cursorAnim } from './libs/Btn';
import { fertilityCheck } from './libs/FertilityCheck';
import { videoInview } from './libs/Video';
import noKeep from './utils/no-keep';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  videoInview();
  noKeep();
  viewport();
  fixedHeader();
  drawer();
  megaMenu();
  createIndex();
  addAutoFunc();
  reservationCalendarFunc();
  lenisPageScroll();
  confirmForm();
  accordionFunc();
  archiveDropdown();
  numKeyFunc();
  ScrollHintFunc();
  tabFunc();
  mvAnim();
  slideLoop();
  cursorAnim();
  sideNav();
  fertilityCheck();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  // modal();
  slider();
  ImageRing();
  inViewAnm();
});
